import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import ContractorUpdate from "./ContractorUpdate";
import { useContractorData } from "../hooks";
import { memo } from "react";
import TaxStatus from "@/components/TaxStatus";
import {
  Module,
  PATH_USER,
  PATH_TIMESHEET_ENTRIES_CONTRACTOR_VISITS,
} from "@/constants";
import { DetailsButton } from "@/components/DetailsButton";
import { Section } from "@/components/details";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { readContractor } from "@/schemas/contractor";

const ContractorDetails = memo(() => {
  const { t } = useTranslation();
  const contractor = useContractorData();
  const usersPermissions = useModulePermissions(Module.Users);

  if (!contractor) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("contractors.details.title")}</CardTitle>
      </CardHeader>
      <CardContent>
        <Section
          variant="card"
          className="mb-6"
          module={Module.Contractors}
          schema={readContractor}
          data={contractor}
        >
          <Section.Field field="user_ref_number" />
          <Section.Field field="personal_id_number" />
          <Section.Field field="birth_date" />
          <Section.Field
            field="gender"
            value={contractor.gender ? t(`gender.${contractor.gender}`) : ""}
          />
          <Section.Field field="registered_by_name" />
          <Section.Field
            field="tax_status"
            value={
              <TaxStatus value={contractor.tax_status} className="w-full" />
            }
          />
          <Section.Field
            field="is_active"
            value={
              <Badge
                variant={contractor.is_active ? "secondary" : "destructive"}
              >
                {contractor.is_active
                  ? t("contractors.status.active")
                  : t("contractors.status.inactive")}
              </Badge>
            }
          />
          {contractor.user_id && usersPermissions.can_read && (
            <Section.Field
              field="user_id"
              label={t("contractors.details.userCard")}
              value={
                <DetailsButton
                  path={PATH_USER}
                  pathParams={{ userId: contractor.user_id }}
                  label="contractors.details.userDetailsButton"
                />
              }
            />
          )}
          <Section.Field
            field="id"
            label={t("contractors.details.timesheet")}
            value={
              <DetailsButton
                path={PATH_TIMESHEET_ENTRIES_CONTRACTOR_VISITS}
                pathParams={{ userId: contractor.id, shiftReportId: null }}
                label="contractors.details.timesheetLink"
              />
            }
          />
        </Section>

        <Separator className="my-6" />

        <ContractorUpdate />
      </CardContent>
    </Card>
  );
});

export default ContractorDetails;
